module.exports = __webpack_public_path__ + "assets/img/c789a2db2873c37d9f307c855633253b.svg";